// Externals
import { configureStore } from "@reduxjs/toolkit";

// Root Reducer
import rootReducer from "./reducers";

// Store
const store = configureStore({
	reducer: rootReducer,
	devTools: true,
});
window.store = store;
// Exports
export default store;
